module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_honda_05.2a8eda53.jpg";